const accounts = [
  {
    title: 'Accounts',
    icon: 'UserIcon',
    enableFeature: true,
    children: [
      {
        title: 'Account Category',
        route: 'account-category',
        hasPermission: 'VIEW_ACCOUNT_CATEGORY',
        enableFeature: true,
      },
      {
        title: 'Charges',
        route: 'charge-management',
        hasPermission: 'VIEW_CHARGE',
        enableFeature: true,
      },
      {
        title: 'Account Officer',
        enableFeature: true,
        children: [
          {
            title: 'Account Officer',
            route: 'account-officer',
            hasPermission: 'VIEW_ACCOUNT_OFFICER',
            enableFeature: true,
          },
          {
            title: 'Re-assign Account Officer',
            route: 'account-officer-reassign',
            hasPermission: 'ACCOUNT_OFFICER_REASSIGNMENT',
            enableFeature: true,
          },
        ],
      },
      {
        title: 'Customer Account',
        enableFeature: true,
        children: [
          {
            title: 'Current and Savings',
            route: 'current-savings-account-list',
            hasPermission: 'VIEW_SAVING_CURRENT_ACCOUNT',
            enableFeature: true,
          },
          {
            title: 'Current and Savings (NIB)',
            route: 'current-savings-account-list-nib',
            hasPermission: 'VIEW_SAVING_CURRENT_ACCOUNT_NIB',
            enableFeature: true,
          },
          {
            title: 'Fixed Deposit',
            route: 'fixed-deposit-list',
            hasPermission: 'VIEW_FIXED_DEPOSIT_ACCOUNT',
            enableFeature: true,
          },
          {
            title: 'Fixed Deposit (NIB)',
            route: 'fixed-deposit-list-nib',
            hasPermission: 'VIEW_FIXED_DEPOSIT_ACCOUNT_NIB',
            enableFeature: true,
          },
          {
            title: 'Memo',
            route: 'memo-management',
            hasPermission: 'VIEW_MEMO',
            enableFeature: true,
          },
          {
            title: 'Liens',
            route: 'liens',
            hasPermission: 'VIEW_LIEN',
            enableFeature: true,
          },
          {
            title: 'Loan',
            route: 'loan-list',
            hasPermission: 'VIEW_LOAN_ACCOUNT',
            enableFeature: true,
          },
          {
            title: 'Loan (NIB)',
            route: 'loan-list-nib',
            hasPermission: 'VIEW_LOAN_ACCOUNT_NIB',
            enableFeature: true,
          },
          {
            title: 'Overdraft',
            route: 'overdraft-list',
            hasPermission: 'VIEW_OVERDRAFT',
            enableFeature: true,
          },
          {
            title: 'Overdraft (NIB)',
            route: 'overdraft-list-nib',
            hasPermission: 'VIEW_OVERDRAFT_NIB',
            enableFeature: true,
          },
          {
            title: 'Account Statement',
            route: 'account-statement',
            hasPermission: 'ACCOUNT_STATEMENT',
            enableFeature: true,
          },
          {
            title: 'Abridged Loan',
            route: 'abridged-loan-account',
            hasPermission: 'VIEW_ABRIDGED_LOAN',
            enableFeature: true,
          },
        ],
      },
      {
        title: 'Customer Information',
        enableFeature: true,
        children: [
          {
            title: 'Individual',
            route: 'individual-customer-information',
            hasPermission: 'VIEW_INDIVIDUAL_CUSTOMER',
            enableFeature: true,
          },
          {
            title: 'Corporate/Group',
            route: 'group-customer-information',
            hasPermission: 'VIEW_GROUP_CUSTOMER',
            enableFeature: true,
          },
          {
            title: 'Customer Relink',
            route: 'customer-relink',
            hasPermission: 'RELINK_CUSTOMER',
            enableFeature: true,
          },
        ],
      },
      {
        title: 'Fees',
        enableFeature: true,
        children: [
          {
            title: 'Loan',
            route: 'loan-fee',
            hasPermission: 'VIEW_LOAN_FEE',
            enableFeature: true,
          },
          {
            title: 'CAM',
            route: 'cam-fee',
            hasPermission: 'VIEW_COT_FEE',
            enableFeature: true,
          },
          {
            title: 'Overdraft',
            route: 'overdraft-fee',
            hasPermission: 'VIEW_OVERDRAFT_FEE',
            enableFeature: true,
          },
        ],
      },
      {
        title: 'Placement',
        route: 'placement',
        hasPermission: 'VIEW_PLACEMENT',
        enableFeature: true,
      },
      {
        title: 'General Ledgers',
        route: 'general-ledger',
        hasPermission: 'VIEW_GENERAL_LEDGER',
        enableFeature: true,
      },
      {
        title: 'Interests',
        route: 'interest-management',
        hasPermission: 'VIEW_INTEREST',
        enableFeature: true,
      },

      // NIB
      {
        title: 'Profits',
        route: 'profit-management',
        hasPermission: 'VIEW_PROFIT',
        enableFeature: true,
      },
      {
        title: 'Penalty',
        route: 'penalty',
        hasPermission: 'VIEW_PENALTY',
        enableFeature: true,
      },
      {
        title: 'Products',
        enableFeature: true,
        children: [
          {
            title: 'FD Product',
            route: 'fd-product',
            hasPermission: 'VIEW_FIXED_DEPOSIT_PRODUCT',
            enableFeature: true,
          },
          {
            title: 'FD Product (NIB)',
            route: 'fd-product-nib',
            hasPermission: 'VIEW_FIXED_DEPOSIT_PRODUCT_NIB',
            enableFeature: true,
          },
          {
            title: 'Loan Product',
            route: 'loan-product-list',
            hasPermission: 'VIEW_LOAN_PRODUCT',
            enableFeature: true,
          },
          {
            title: 'Loan Product (NIB)',
            route: 'loan-product-list-nib',
            hasPermission: 'VIEW_LOAN_PRODUCT_NIB',
            enableFeature: true,
          },
          {
            title: 'CASA Product',
            route: 'casa-product-list',
            hasPermission: 'VIEW_SAVING_CURRENT_PRODUCT',
            enableFeature: true,
          },
          {
            title: 'CASA Product (NIB)',
            route: 'casa-product-list-nib',
            hasPermission: 'VIEW_SAVING_CURRENT_PRODUCT_NIB',
            enableFeature: true,
          },
        ],
      },
      {
        title: 'Fixed Asset Register',
        route: 'fixed-asset-register',
        hasPermission: 'VIEW_FIXED_ASSET',
        enableFeature: true,
      },
      {
        title: 'Prepayment Amortization',
        route: 'prepayment-amortization',
        hasPermission: 'VIEW_PREPAYMENT_AMORTIZATION',
        enableFeature: true,
      },
      {
        title: 'Standing Order',
        route: 'standing-order',
        hasPermission: 'VIEW_STANDING_ORDERS',
        enableFeature: true,
      },
    ],
  },
]

export default accounts
